// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__YWUZr","line":"styles_line__YROVT","tickets":"styles_tickets__8cKer","title":"styles_title__cPsil"};